import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle, Upload } from "lucide-react";
import { resolveSite } from "../lib/siteConfig";
import { usePublicData } from "../hooks/usePublicData";
import { useLanguage } from "../context/LanguageContext";
import { pub } from "../lib/pubThemeClasses";

export default function CTAStrip() {
  const { settings } = usePublicData();
  const siteConfig = resolveSite(settings);
  const { t } = useLanguage();

  return (
    <section data-testid="cta-strip" className={`relative border-y bg-surface-2 overflow-hidden ${pub.borderSubtle}`}>
      <div className="absolute inset-0 grid-lines opacity-[0.55] dark:opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#FF4F00] mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-[#FF4F00]" /> {t("cta.eyebrow")}
          </div>
          <h2 className={`font-sans text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight leading-[1.1] ${pub.heroHeading}`}>
            {t("cta.headline.line1")}
            <br />
            <span className="text-[#FF4F00]">{t("cta.headline.line2.bold")}</span> {t("cta.headline.line3")}
          </h2>
          <p className={`mt-5 max-w-2xl text-base md:text-lg font-sans ${pub.muted}`}>{t("cta.body")}</p>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-3">
          <Link
            to="/teklif-al#teklif-yukle"
            data-testid="ctastrip-quote-button"
            className="inline-flex items-center justify-between bg-[#FF4F00] hover:bg-[#E64700] text-black font-semibold uppercase tracking-wide text-sm px-6 py-5 transition-all hover:-translate-y-0.5"
          >
            <span className="inline-flex items-center gap-3">
              <Upload className="w-5 h-5" />
              {t("cta.uploadModel")}
            </span>
            <ArrowUpRight className="w-5 h-5" />
          </Link>
          <Link
            to="/teklif-al"
            data-testid="ctastrip-price-cta"
            className={`inline-flex items-center justify-between font-semibold uppercase tracking-wide text-sm px-6 py-5 transition-colors ${pub.btnGhost} ${pub.hoverText}`}
          >
            {t("cta.seePrice")}
            <ArrowUpRight className="w-5 h-5" />
          </Link>
          <a
            href={siteConfig.whatsappLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="ctastrip-whatsapp-button"
            className={`inline-flex items-center justify-between font-mono text-xs uppercase tracking-[0.2em] text-neutral-600 dark:text-[#a89f93] px-6 py-2 transition-colors hover:text-[#FF4F00]`}
          >
            <span className="inline-flex items-center gap-2">
              <MessageCircle className="w-4 h-4" />
              {t("whatsapp.brand")}
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
